export default __webpack_public_path__ + "static/media/Cutoff.e6b5eeab.svg";